"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = exports.Preferences = void 0;
const auth_1 = require("@completeanatomy/auth");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const event_bus_1 = require("@completeanatomy/event-bus");
const http_1 = require("@completeanatomy/http");
const storage_1 = require("@completeanatomy/storage");
const store_1 = require("@completeanatomy/store");
const websocket_1 = require("@completeanatomy/websocket");
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
require("reflect-metadata");
const typedi_1 = require("typedi");
const default_1 = require("./default");
const types_1 = require("./types");
Object.defineProperty(exports, "Language", { enumerable: true, get: function () { return types_1.Language; } });
let Preferences = class Preferences {
    constructor(bridge, http, websocket, auth, store, storage, eventBus) {
        this.bridge = bridge;
        this.http = http;
        this.websocket = websocket;
        this.auth = auth;
        this.store = store;
        this.storage = storage;
        this.eventBus = eventBus;
        /**
         * Key for native cache storage
         */
        this.storageKey = 'preferences';
        /**
         * Current version of Preferences
         */
        this.version = 1.3;
        /**
         * Preferences object identifier in the AppState
         * @private
         */
        this.preferencesIdentifier = 'preferences';
        /**
         * Disable handling socket messages
         * @private
         */
        this.ignoreWebSocket = false;
        this.bridge.emit(bridge_schema_1.bridgeObjectAdded, {
            identifier: this.preferencesIdentifier,
            object: default_1.defaultValues,
        });
        this.enableWebSocketHandling = (0, lodash_debounce_1.default)(this.enableWebSocketHandling, 1000);
        this.togglePreferencesInNative(default_1.defaultValues);
        this.eventBus.on(event_bus_1.AuthEvent.NeedUpdateUserData, () => {
            this.fetch();
        });
        this.eventBus.on(event_bus_1.AuthEvent.NeedClearUserData, () => {
            this.saveToAppState(default_1.defaultValues);
            this.togglePreferencesInNative(default_1.defaultValues);
        });
        this.websocket.addListener(types_1.WebSocketEvent.AddPreferences, this.handleWebSocketMessage, this);
        this.websocket.addListener(types_1.WebSocketEvent.ChangePreferences, this.handleWebSocketMessage, this);
    }
    /**
     * Fetch all user preferences from the API to the AppState
     */
    fetch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.auth.isAuthenticated()) {
                return;
            }
            try {
                const response = yield this.http.get({
                    path: 'preferences/',
                });
                if (response.status === 404) {
                    const preferencesInApiFormat = this.transformToAPIFormat(default_1.defaultValues);
                    yield this.putToNativeCache(default_1.defaultValues);
                    yield this.sendToApi(preferencesInApiFormat);
                    return;
                }
                const preferences = (yield response.json())
                    .preferences;
                const { newFeatures, newUIFeatures } = this.checkForNewFeatures(preferences);
                if (newFeatures.length || newUIFeatures.length) {
                    //check if new features activated by default and send to API
                    newFeatures.forEach(feature => {
                        preferences.features[feature] = default_1.defaultValues.activated.includes(types_1.PreferencesDictionary[feature]);
                    });
                    newUIFeatures.forEach(uiFeature => {
                        preferences.uiFeatures[uiFeature] = default_1.defaultValues.activated.includes(types_1.PreferencesDictionary[uiFeature]);
                    });
                    yield this.sendToApi(preferences);
                }
                const bridgeObject = this.transformToAppStateFormat(preferences);
                this.saveToAppState(bridgeObject);
                this.togglePreferencesInNative(bridgeObject);
                this.version = preferences.version;
            }
            catch (e) {
                const bridgeObject = (yield this.getFromNativeCache()) || default_1.defaultValues;
                this.saveToAppState(bridgeObject);
                this.togglePreferencesInNative(bridgeObject);
            }
        });
    }
    /**
     * Toggle boolean feature by PreferenceBoolOption type
     *
     * @param preference - toggling preference
     */
    toggle(preference) {
        return __awaiter(this, void 0, void 0, function* () {
            const { preferences } = this.store.getState();
            if (preferences === undefined) {
                return;
            }
            const activatedSet = new Set(preferences.activated);
            const isActive = activatedSet.has(preference);
            if (isActive) {
                activatedSet.delete(preference);
            }
            else {
                activatedSet.add(preference);
            }
            this.bridge.togglePreferenceBoolOption({
                type: preference,
                value: !isActive,
            });
            const activated = Array.from(activatedSet);
            const updatedPreferences = Object.assign(Object.assign({}, preferences), { activated });
            const preferencesInAPIFormat = this.transformToAPIFormat(updatedPreferences);
            this.saveToAppState(updatedPreferences);
            yield this.sendToApi(preferencesInAPIFormat);
        });
    }
    /**
     * Set new info box tools order
     *
     * @param order - new order of tools
     */
    setToolsOrder(order) {
        return __awaiter(this, void 0, void 0, function* () {
            const { preferences } = this.store.getState();
            if (preferences === undefined) {
                return;
            }
            const updatedPreferences = Object.assign(Object.assign({}, preferences), { infoBoxTabsOrder: order });
            const preferencesInAPIFormat = this.transformToAPIFormat(updatedPreferences);
            this.saveToAppState(updatedPreferences);
            yield this.sendToApi(preferencesInAPIFormat);
        });
    }
    /**
     * Select application language
     *
     * @param language - selected language
     */
    selectApplicationLanguage(language) {
        return __awaiter(this, void 0, void 0, function* () {
            this.bridge.setAppLanguage(language);
        });
    }
    getValue(name) {
        const { preferences } = this.store.getState();
        switch (name) {
            case 'Language':
                return preferences.language;
            case 'TabsOrder':
                return preferences.infoBoxTabsOrder;
            case 'PushNotifications':
                return (preferences.pushNotificationsState === types_1.PushNotificationsState.True);
            default:
                return preferences.activated.includes(bridge_schema_1.PreferenceBoolOption[name]);
        }
    }
    /**
     * Send preferences object to the API
     *
     * @param preferences - preferences object
     * @private
     */
    sendToApi(preferences) {
        return __awaiter(this, void 0, void 0, function* () {
            this.disableWebSocketHandling();
            yield this.http.post({
                path: 'preferences/',
                data: {
                    preferences,
                },
            });
            this.enableWebSocketHandling();
        });
    }
    enableWebSocketHandling() {
        this.ignoreWebSocket = false;
    }
    disableWebSocketHandling() {
        this.ignoreWebSocket = true;
    }
    /**
     * Transform preferences object from an API format to an AppState format
     *
     * @param preferences - preferences object in the API format
     * @private
     */
    transformToAppStateFormat(preferences) {
        const activatedFeatures = Object.keys(preferences.features)
            .filter(key => preferences.features[key])
            .map(feature => types_1.PreferencesDictionary[feature])
            .filter(value => value !== undefined);
        const activatedUIFeatures = Object.keys(preferences.uiFeatures)
            .filter(key => preferences.uiFeatures[key])
            .map(uiFeature => types_1.PreferencesDictionary[uiFeature])
            .filter(value => value !== undefined);
        const activated = Array.from(new Set([...activatedFeatures, ...activatedUIFeatures]));
        if (preferences.theme === types_1.Theme.Dark) {
            activated.push(bridge_schema_1.PreferenceBoolOption.DarkTheme);
        }
        //sort all activated feature to simplify handle it
        activated.sort((a, b) => a - b);
        return {
            activated,
            infoBoxTabsOrder: preferences.toolsOrder,
            language: types_1.Language.English,
        };
    }
    /**
     * Transform preferences object from an AppState format to an API format
     *
     * @param preferences - preferences object in the AppState format
     * @private
     */
    transformToAPIFormat(preferences) {
        const theme = preferences.activated.includes(bridge_schema_1.PreferenceBoolOption.DarkTheme)
            ? types_1.Theme.Dark
            : types_1.Theme.Light;
        const toolsOrder = preferences.infoBoxTabsOrder;
        const activatedInApiForm = Object.entries(types_1.PreferencesDictionary).reduce((acc, [key, value]) => {
            return Object.assign(Object.assign({}, acc), { [key]: preferences.activated.includes(value) });
        }, {});
        const features = Object.entries(activatedInApiForm)
            .filter(([key, _]) => Object.values(types_1.Features).includes(key))
            .reduce((acc, [key, value]) => {
            return Object.assign(Object.assign({}, acc), { [key]: value });
        }, {});
        const uiFeatures = Object.entries(activatedInApiForm)
            .filter(([key, _]) => Object.values(types_1.UIFeatures).includes(key))
            .reduce((acc, [key, value]) => {
            return Object.assign(Object.assign({}, acc), { [key]: value });
        }, {});
        return {
            features,
            theme,
            toolsOrder,
            uiFeatures,
            version: this.version,
        };
    }
    /**
     * Checks features in preferences object from an API with existed
     *
     * @param preferences - preferences object in the API format
     * @private
     */
    checkForNewFeatures(preferences) {
        const existedFeatures = Object.keys(preferences.features);
        const allFeatures = Object.values(types_1.Features);
        const newFeatures = allFeatures.reduce((acc, feature) => {
            if (!existedFeatures.includes(feature)) {
                acc.push(feature);
            }
            return acc;
        }, []);
        const existedUIFeatures = Object.keys(preferences.uiFeatures);
        const allUIFeatures = Object.values(types_1.UIFeatures);
        const newUIFeatures = allUIFeatures.reduce((acc, uiFeature) => {
            if (!existedUIFeatures.includes(uiFeature)) {
                acc.push(uiFeature);
            }
            return acc;
        }, []);
        return { newFeatures, newUIFeatures };
    }
    /**
     * Save preferences object to the AppState
     *
     * @param preferences - preferences object in the AppState format
     * @private
     */
    saveToAppState(preferences) {
        this.putToNativeCache(preferences);
        this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
            identifier: this.preferencesIdentifier,
            keyPath: '',
            changes: preferences,
        });
    }
    /**
     * Handler for events with preferences changing
     *
     * @param message - websocket message with updated preferences
     * @private
     */
    handleWebSocketMessage(message) {
        if (this.ignoreWebSocket) {
            return;
        }
        const preferencesInApiFormat = message.data.preferences;
        const preferencesInAppStateFormat = this.transformToAppStateFormat(preferencesInApiFormat);
        if (!this.comparePreferencesWithAppState(preferencesInAppStateFormat)) {
            this.saveToAppState(preferencesInAppStateFormat);
            this.togglePreferencesInNative(preferencesInAppStateFormat);
        }
    }
    /**
     * Compare a preferences object with the AppState
     * Returns 'true' if objects are equal
     *
     * @param preferences - an object to compare with the AppState
     * @private
     */
    comparePreferencesWithAppState(preferences) {
        const { preferences: preferencesFromAppState } = this.store.getState();
        return (0, lodash_isequal_1.default)(preferencesFromAppState, preferences);
    }
    /**
     * Method toggle preferences in the Native
     * This method can be used for setting default preferences in the Native side
     *
     * @private
     */
    togglePreferencesInNative(preferences) {
        const activated = preferences.activated;
        Object.values(bridge_schema_1.PreferenceBoolOption)
            .filter((feature) => typeof feature === 'number') // Object.values returns an array of Names and Values if enum is numeric
            .forEach(feature => {
            const isActive = activated.includes(feature);
            this.bridge.togglePreferenceBoolOption({
                type: feature,
                value: isActive,
            });
        });
    }
    /**
     * Save preferences to native storage
     *
     * @param preferences - preferences to save
     */
    putToNativeCache(preferences) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.put(this.storageKey, preferences);
        });
    }
    /**
     * Retrieves preferences from native storage
     */
    getFromNativeCache() {
        return this.storage.get(this.storageKey);
    }
};
exports.Preferences = Preferences;
/**
 * Name of exported module property
 */
Preferences.exportName = 'preferences';
exports.Preferences = Preferences = __decorate([
    (0, typedi_1.Service)(),
    __param(4, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [bridge_schema_1.BridgeInterface,
        http_1.HTTP,
        websocket_1.WebSocketManager,
        auth_1.Auth, Object, storage_1.Storage,
        event_bus_1.EventBus])
], Preferences);
